import { call, put } from 'redux-saga/effects';
import {
  initiateNotifications,
  fetchUser,
  getNotificationsStatus,
} from '../../../services';

export function* setUser({ user }) {
  const id = user.username;
  try {
    const userApi = yield call(fetchUser);
    if (userApi.data.status === true) {
      //!! As notificações fora da tela de notificações estão inativas
      //!! por conta disso devemos comentar a chamada da API de notificações
      // const notificationsAmount = yield call(getNotificationAmount, 1, 5);

      const status = yield call(getNotificationsStatus);
      initiateNotifications(id);

      yield put({
        type: 'NOTIFICATION/SET_STATUS',
        status: status.data,
      });

      // yield put({
      //   type: 'NOTIFICATION/SET_NOTIFICATION_AMOUNT',
      //   amount: notificationsAmount.data.count,
      //   amountDeleted: 20,
      //   amountArchived: 20,
      // });
      yield put({
        type: 'USUARIO/SET_USER',
        user: userApi.data,
      });
      yield put({
        type: 'USUARIO/SET_FAVORITE_VARS',
        vars: userApi.data.things,
      });
      // Preferencias de UI (tema etc) vindas do perfil. Backend pode
      // ainda nao mandar o campo (deploy em andamento) — default {} pra
      // o App cair na preferencia local/default sem quebrar.
      yield put({
        type: 'USUARIO/SET_PREFERENCES',
        preferences: userApi.data.preferences || {},
      });
    } else if (userApi.data.status === false) {
      yield put({
        type: 'USUARIO/SET_ERROR',
        error: 'O usuário está inativado',
      });
    }
  } catch {
    yield put({
      type: 'USUARIO/SET_ERROR',
      error: 'Não foi possível buscar as informações do usuário',
    });
  }
}

export function* setInitialize() {
  yield put({
    type: 'USUARIO/SET_INITIALIZE',
  });
}
